var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{attrs:{"id":"clouds"}},_vm._l((_vm.clouds),function(cloud,index){return _c('div',{key:cloud+index},[_c('div',{staticClass:"cloud",attrs:{"id":_vm.ids[index]},domProps:{"innerHTML":_vm._s(cloud)}})])})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14df100c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clouds.vue
// module id = 77
// module chunks = 0